// Wave E — SubscriptionGate scaffold.
//
// In v1 this component renders children unconditionally. The boundary it
// marks in router.tsx exists so Wave F (or later) can drop in real
// subscription-checking logic without re-wrapping every page.

import type { ReactNode } from 'react';
import type { SubscriptionFeature } from '../../types/subscription';

export interface SubscriptionGateProps {
  feature: SubscriptionFeature;
  children: ReactNode;
  fallback?: ReactNode;
}

export function SubscriptionGate({
  feature,
  children,
}: SubscriptionGateProps): JSX.Element {
  // TODO: when superadmin + subscription tiers are implemented,
  // check company subscription level against feature flag here.
  // Feature strings are defined in src/types/subscription.ts (create that too).
  void feature;
  return <>{children}</>;
}
